import React from 'react';
import Aerolineas from '../assets/logoAerolineas.svg'; // Reemplaza con tus nombres de archivos SVG reales
import Flybondi from '../assets/logoFlybondi.svg';
import Jetsmart from '../assets/logoJetsmart.svg';

function AirlinesSection() {
  const airlines = [
    { name: 'Aerolíneas Argentinas', logo: Aerolineas },
    { name: 'flybondi', logo: Flybondi },
    { name: 'Jetsmart', logo: Jetsmart },
  ];

  return (
    <section className="bg-white py-12">
      <div className="container mx-auto px-4">
        <h2 className="text-2xl font-bold font-montserrat text-[#1E3A5F] text-center mb-12">TRABAJAMOS CON LAS MEJORES AEROLÍNEAS</h2>
        <div className="flex justify-around flex-wrap">
          {airlines.map((airline, index) => (
            <div key={index} className="text-center opacity-70 hover:opacity-100 transition-opacity duration-300">
              <img src={airline.logo} alt={airline.name} className="w-40 h-auto" /> {/* Ajusta w-24 para el tamaño deseado */}
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}

export default AirlinesSection;